import React from 'react';
const NlFlag = () => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#clip0_40010504_57270)" },
        React.createElement("rect", { x: "1", y: "1", width: "24", height: "24", rx: "4", fill: "white" }),
        React.createElement("g", { clipPath: "url(#clip1_40010504_57270)" },
            React.createElement("path", { d: "M0 -0.8125H26V26.8125H0V-0.8125Z", fill: "#21468B" }),
            React.createElement("path", { d: "M0 -0.8125H26V17.6042H0V-0.8125Z", fill: "white" }),
            React.createElement("path", { d: "M0 -0.8125H26V8.39583H0V-0.8125Z", fill: "#AE1C28" }))),
    React.createElement("rect", { x: "0.5", y: "0.5", width: "25", height: "25", rx: "4.5", stroke: "#EDEBE9" }),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_40010504_57270" },
            React.createElement("rect", { x: "1", y: "1", width: "24", height: "24", rx: "4", fill: "white" })),
        React.createElement("clipPath", { id: "clip1_40010504_57270" },
            React.createElement("rect", { width: "26", height: "27.625", fill: "white", transform: "translate(0 -0.8125)" })))));
export default NlFlag;
//# sourceMappingURL=nl.js.map